import React from "react";
import { Mail, Twitter, Linkedin, Facebook } from "lucide-react";

const socials = [
    { id: "twitter", icon: Twitter, href: "#", label: "Twitter" },
    { id: "linkedin", icon: Linkedin, href: "#", label: "LinkedIn" },
    { id: "facebook", icon: Facebook, href: "#", label: "Facebook" },
    {
        id: "email",
        icon: Mail,
        href: "mailto:support@xpomarkets.co",
        label: "Email support@xpomarkets.co",
        title: "support@xpomarkets.co",
    },
];

const telegramChannels = [
    {
        id: "official",
        label: "Official Channel",
        href: "https://t.me/+qdNu6BdxmZ0yNjc0",
        testId: "footer-telegram-cta",
    },
    {
        id: "future-instincts",
        label: "Future Instincts",
        href: "https://t.me/futureinstincts",
        testId: "footer-telegram-future-instincts",
    },
    {
        id: "market-trends",
        label: "Market Trends",
        href: "https://t.me/globalmarkettrendss",
        testId: "footer-telegram-market-trends",
    },
];

function TelegramIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path d="M9.04 15.36 8.7 19.4c.49 0 .7-.21.95-.46l2.28-2.18 4.72 3.46c.87.48 1.49.23 1.72-.8L21.94 5.3l.01-.01c.27-1.27-.46-1.77-1.3-1.46L3.4 10.49c-1.24.48-1.22 1.18-.21 1.5l4.43 1.38 10.29-6.49c.48-.32.93-.14.57.18Z" />
        </svg>
    );
}

export default function FooterSocial() {
    return (
        <>
            <div className="flex gap-3 mt-5">
                {socials.map((s) => (
                    <a
                        key={s.id}
                        href={s.href}
                        data-testid={`footer-social-${s.id}`}
                        aria-label={s.label}
                        title={s.title}
                        className="w-9 h-9 grid place-items-center rounded-lg border border-white/10 text-slate-400 hover:text-[#A6E3DC] hover:border-[#A6E3DC]/40 transition"
                    >
                        <s.icon size={16} />
                    </a>
                ))}
            </div>
            {telegramChannels.map((t) => (
                <a
                    key={t.id}
                    href={t.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={t.testId}
                    className="mt-3 w-[180px] flex items-center justify-center gap-2 px-3 py-2.5 rounded-lg border border-[#A6E3DC]/40 bg-[#A6E3DC]/10 text-[#A6E3DC] font-semibold text-xs hover:bg-[#A6E3DC]/20 hover:border-[#A6E3DC]/70 transition"
                >
                    <TelegramIcon />
                    {t.label}
                </a>
            ))}
        </>
    );
}
